import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

function FixMapResize() {
  const map = useMap();

  useEffect(() => {
    console.log("FixMapResize effect triggered");

    // Short initial delay for container layout
    const initialTimeout = setTimeout(() => {
      map.invalidateSize();
    }, 150);

    // Invalidate on window resize (in case container size changes)
    const handleResize = () => map.invalidateSize();
    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(initialTimeout);
      window.removeEventListener('resize', handleResize);
    };
  }, [map]);

  return null;
}

export default FixMapResize;
